<template>
  <div class="users content-container flex-column">
    <div class="content-wrap">
      <!-- Górny pasek z menu, bez dodatkowej zawartości (wizualne tło po lewej) -->
      <div class="d-flex users-section-container no-content">
        <div class="users-section"></div>
        <div class="content-wrap">
          <TopMenu />
        </div>
      </div>

      <!-- Sekcja główna historii aktywności użytkowników -->
      <div class="d-flex users-section-container">
        <div class="users-section">
          <span>
            {{ t('users-activity-history') }}
          </span>
        </div>
        <div class="content-wrap">
          <h3>
            {{ t('users-activity-history').toUpperCase() }}
            <!-- Przycisk pobierania PDF (obecnie tylko etykieta, możesz powiązać z funkcją jeśli chcesz) -->
            <button class="btn" @click="retrieveZip" :disabled="isDownloading">
              <span>PDF</span>
            </button>
          </h3>
          <div class="collapse show" id="userHistory">
            <!-- Komponent wyświetlający historię aktywności użytkowników -->
            <UserActivityList />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopMenu from "../components/TopMenu.vue";
import UserActivityList from "@/components/UserActivityList";
import Users from "@/services/Users";
import moment from "moment";

export default {
  name: "HomeView",
  components: {
    UserActivityList,
    TopMenu,
  },
  data() {
    return {
      isDownloading: false, // Czy trwa pobieranie pliku PDF
    };
  },
  methods: {
    // Pobieranie logów aktywności do pliku ZIP (ostatnie 7 dni)
    retrieveZip() {
      this.isDownloading = true;
      const dateFrom = moment().subtract(7, "days").toISOString(false); // Początek zakresu dat
      const dateTo = moment().toISOString(false);                      // Koniec zakresu dat (dziś)
      Users.getZip(dateFrom, dateTo)
        .then((data) => {
          // Po otrzymaniu linku do pliku wywołujemy fetch i ściągamy go jako blob
          Users.fetch(data.link)
            .then((response) => {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(response);
              link.download = "user_logs";
              link.click(); // Pobieranie pliku przez przeglądarkę
              this.isDownloading = false;
              URL.revokeObjectURL(link.href); // Czyścimy zasoby
            })
            .catch(console.error);
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.users-section-container {
  width: 100%;
}

.users-section {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}

.users-section > span {
  padding: 10px 25px;
  position: relative;
  display: block;
}

.content-wrap h3 {
  background-color: white;
  padding: 10px 20px;
  margin-bottom: 0;
  position: relative;
}

h3 button {
  position: absolute;
  right: 20px;
  top: 17%;
  background-color: #e0e0e0;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  min-height: 28px;
  font-weight: normal;
  padding: 0;
  border: 0;
  font-size: 12px;
}

.no-content {
  min-height: auto;
}
.icon {
  margin: 5px;
  height: 15px;
  width: 35px;
}
.icon-collapse {
  background: url("../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 10px;
}
.collapsed.icon-collapse {
  background: url("../assets/icons/rozwin.png") no-repeat left top;
}
</style>
